"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cardHeaderClassNames: function() {
        return cardHeaderClassNames;
    },
    cardHeaderCSSVars: function() {
        return cardHeaderCSSVars;
    },
    useCardHeaderStyles_unstable: function() {
        return useCardHeaderStyles_unstable;
    }
});
const _react = require("@griffel/react");
const cardHeaderClassNames = {
    root: 'fui-CardHeader',
    image: 'fui-CardHeader__image',
    header: 'fui-CardHeader__header',
    description: 'fui-CardHeader__description',
    action: 'fui-CardHeader__action'
};
const cardHeaderCSSVars = {
    cardHeaderGapVar: '--fui-CardHeader--gap'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bkc6ea2: "fkufhic",
        mc9l5x: "f13qh94s",
        t4k1zu: "f8a668j",
        Bt984gj: "f122n59"
    },
    image: {
        mc9l5x: "ftuwxu6",
        t21cq0: [
            "fql5097",
            "f6yss9k"
        ],
        Br312pm: "fwpfdsa",
        Ijaq50: "fldnz9j"
    },
    header: {
        Br312pm: "fd46tj4",
        Ijaq50: "f16hsg94",
        mc9l5x: "f22iagw"
    },
    description: {
        Br312pm: "fd46tj4",
        Ijaq50: "faunodf",
        mc9l5x: "f22iagw"
    },
    action: {
        Frg6f3: [
            "f6yss9k",
            "fql5097"
        ],
        Br312pm: "fis13di",
        Ijaq50: "fldnz9j"
    }
}, {
    d: [
        ".fkufhic{--fui-CardHeader--gap:12px;}",
        ".f13qh94s{display:grid;}",
        ".f8a668j{grid-auto-columns:min-content 1fr min-content;}",
        ".f122n59{align-items:center;}",
        ".ftuwxu6{display:inline-flex;}",
        ".fql5097{margin-right:var(--fui-CardHeader--gap);}",
        ".f6yss9k{margin-left:var(--fui-CardHeader--gap);}",
        ".fwpfdsa{grid-column-start:1;}",
        ".fldnz9j{grid-row-start:span 2;}",
        ".fd46tj4{grid-column-start:2;}",
        ".f16hsg94{grid-row-start:1;}",
        ".f22iagw{display:flex;}",
        ".faunodf{grid-row-start:2;}",
        ".fis13di{grid-column-start:3;}"
    ]
});
const useCardHeaderStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(cardHeaderClassNames.root, styles.root, state.root.className);
    if (state.image) {
        state.image.className = (0, _react.mergeClasses)(cardHeaderClassNames.image, styles.image, state.image.className);
    }
    if (state.header) {
        state.header.className = (0, _react.mergeClasses)(cardHeaderClassNames.header, styles.header, state.header.className);
    }
    if (state.description) {
        state.description.className = (0, _react.mergeClasses)(cardHeaderClassNames.description, styles.description, state.description.className);
    }
    if (state.action) {
        state.action.className = (0, _react.mergeClasses)(cardHeaderClassNames.action, styles.action, state.action.className);
    }
    return state;
}; //# sourceMappingURL=useCardHeaderStyles.styles.js.map
